import React from 'react';
import leasePage from 'decorators/leasePage';
import Lease from 'components/Lease/Lease';
import { Link } from 'react-router-dom';

export const ViewLease = ({ lease, notFound, isAdmin }) => {
  if (notFound) {
    return <div>Not Found</div>;
  }

  if (!lease) {
    return <div>Loading...</div>;
  }

  const subId =
    lease.simo_subscription || lease.att_subscription || lease.subscription;
  let prefix = '';
  if (lease.simo_subscription) {
    prefix = '/simo';
  } else if (lease.att_subscription) {
    prefix = '/att';
  }

  return (
    <div>
      <Lease lease={lease} />
      {!lease.tracfone_subscription && (
        <ul>
          <li>
            <Link
              to={`${prefix}/subscriptions/${subId}/update-lease/${lease.id}`}
            >
              Edit Lease
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
};

const WrapperViewLease = leasePage(ViewLease);

export default WrapperViewLease;
